export const fr = {
    connectedAppConnect: {
        success: "{{app}} connecté avec succès.",
        error: "Impossible de connecter {{app}}. Veuillez réessayer.",
        popupBlocked: "Autorisez les fenêtres contextuelles pour ce site afin de connecter {{app}}.",
        popupLoading: "Connexion en cours…",
        unsupported: "Cette application ne peut pas encore être connectée depuis Workleap."
    }
};
